<template>
	<div class="m_container background-white" v-if="isLoginAvailable">
		<div v-if="isLoginSpinner" class="text-center">
			<b-spinner variant="primary" class="spinner-custom"/>
		</div>
		<div v-else>
			<div style="max-width: 730px; margin: 0 auto;">
				<h1 class="login_headline">{{ $t('loginTitle') }}</h1>
				<b-tabs content-class="mt-3">
					<b-tab v-bind:title="$t('otpTabTitle')" :active="isOtpTab">
						<div class="last_input" v-show="showInputMsisdn">
							<div class="input_headline">{{ $t('loginInputMsisdnTitle') }}</div>
							<span><input class="text_input" v-model="serviceId" v-bind:placeholder="$t('loginPhonePlaceHolder')" :class="isAuhtneticationOtpError ? 'show-error' : ''"> </span>
						</div>
						<div class="last_input" v-show="showInputOtp">
							<div class="input_headline" style="padding-top: 22px; padding-bottom: 8px;">{{ $t('loginInputOtpTitle') }}</div>
							<div class="message_upresneni" v-html="$t('loginInputOtpDesc')"></div>
							<span><input class="text_input" v-model="otp" v-bind:placeholder="$t('loginOneTimePassPlaceholder')" :class="isLoginOtpError ? 'show-error' : ''"> </span>
						</div>
						<div class="warning_wrapper" v-if="isAuhtneticationOtpError">
							<div class="warning">
								<b-icon class="warning_icon" icon="exclamation-circle"></b-icon>
								<span v-html="$t('loginInputLoginError')"></span>
							</div>
						</div>
						<div class="warning_wrapper" v-if="isLoginOtpError">
							<div class="warning">
								<b-icon class="warning_icon" icon="exclamation-circle"></b-icon>
								<span style="cursor: pointer;" v-on:click="createOtpAgain" v-html="$t('loginInputOtpError')"></span>
							</div>
						</div>
						<div class="wrapper_centered" v-show="showInputMsisdn">
							<button class="btn_app btn_main" v-on:click="createOtp">{{ $t('loginSendOtp') }}</button>
						</div>
						<div class="wrapper_centered" v-show="showInputOtp">
							<button class="btn_app btn_main" v-on:click="loginByOtp">{{ $t('loginOtpCta') }}</button>
						</div>
<!--						<div class="potize_s_prihlasenim">{{ $t('loginHelpTitle') }}</div>-->
					</b-tab>
					<b-tab v-bind:title="$t('usernameTabTitle')" :active="!isOtpTab">
						<div>
							<div class="input_headline">{{ $t('loginInputUsernameTitle') }}</div>
							<span><input class="text_input" v-model="username" v-bind:placeholder="$t('loginUsernamePlaceholder')" :class="isLoginUsernameError ? 'show-error' : ''"> </span>
						</div>
						<div class="last_input">
							<div class="input_headline" style="padding-top: 22px;">{{ $t('loginInputPassword') }}</div>
							<span><input type="password" class="text_input" v-model="password" v-bind:placeholder="$t('loginPassPlaceholder')" :class="isLoginUsernameError ? 'show-error' : ''"> </span>
						</div>
						<div class="warning_wrapper" v-if="isLoginUsernameError">
							<div class="warning">
								<b-icon class="warning_icon" icon="exclamation-circle"></b-icon>
								<span v-html="$t('loginInputPasswordError')"></span>
							</div>
						</div>
						<div class="wrapper_centered">
							<button class="btn_app btn_main" v-on:click="loginByUser" value="Login">{{ $t('loginCta') }}</button>
						</div>
					</b-tab>
				</b-tabs>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "LoginComponent.vue",
	data() {
		return {
			username: '',
			password: '',
			serviceId: '',
			otp: ''
		}
	},
	computed: {
		isLoginAvailable() {
			return this.$store.state.jwt == undefined || this.$store.state.jwt.length < 1;
		},
		isLoginOtpError() {
			return this.$store.state.errorOtp
		},
		isAuhtneticationOtpError() {
			return this.$store.state.authOtpError
		},
		isLoginUsernameError() {
			return this.$store.state.errorUsername
		},
		isLoginSpinner() {
			return this.$store.state.loginSpinner
		},
		showInputOtp() {
			return this.$store.state.showInputOtp
		},
		showInputMsisdn() {
			return this.$store.state.showInputMsisdn
		},
		isOtpTab() {
			return this.$store.state.isOtpTab
		}
	},
	methods: {
		loginByUser() {
			const params = {username: this.username, password: this.password, type: 'NAME'}
			this.$store.state.isOtpTab = false
			this.$store.dispatch('LOGIN_NEW_USER', params)
		},
		createOtp() {
			const params = {serviceId: this.serviceId, type: 'COTP'}
			this.$store.state.isOtpTab = true
			this.$store.dispatch('LOGIN_NEW_USER', params)
		},
		createOtpAgain() {
			this.createOtp()
			this.otp = ''
		},
		loginByOtp() {
			const params = {serviceId: this.serviceId, otp: this.otp}
			this.$store.state.isOtpTab = true
			this.$store.dispatch('LOGIN_NEW_USER', params)
		},
		clearWarnings() {
			this.$store.dispatch('CLEAR_LOGIN_ERROR')
		},
		logout() {
			this.$store.dispatch('LOGOUT')
		}
	}

}
</script>

<style scoped>

.show-error {
	border-bottom: 2px solid #FF9A1E !important;
}

.spinner-custom {
	color: #e20074 !important;
	margin-top: 35px;
	width: 3rem;
	height: 3rem;
	border-width: 2px;
}

.m_container {
	max-width: 1300px;
	margin: 0 auto;
	padding-left: 15px;
	padding-right: 15px;
}

.btn_main {
	color: #FFFFFF;
	width: 210px;
	background: #E20074;
	margin-top: 24px;
	place-self: center;
}

.last_input {
	padding-bottom: 16px;
}

.wrapper_centered {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	margin: 0 auto;
}

.background-white {
	margin: 0 auto;
	padding: 32px 64px 40px 64px;
}

.login_headline {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 40px;
	line-height: 46px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
}

.input_headline {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 21px;
	line-height: 24px;
	letter-spacing: -0.3px;
	color: #262626;
	padding-bottom: 12px;
	padding-top: 3px;
}

.message_upresneni {
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: -0.3px;
	color: #6C6C6C;
	padding-bottom: 20px;
}

.text_input {
	padding: 13px 12px 13px 12px;
	width: 100%;
	background-color: #F2F4F9;
	height: 48px;
	border-radius: 4px;
	border: none;
	border-bottom: 2px solid rgba(35, 84, 130, 0.15);
	padding-right: 40px;
	margin: 0 !important;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 16px;
	color: #262626;
}

.text_input:focus {
	border: none;
	outline: none !important;
	border-bottom: 2px solid #e20074;
	-webkit-box-shadow: none !important;
	box-shadow: none !important;
}

.warning_wrapper {
	position: relative;
}

.warning {
	width: 100%;
	border-radius: 4px;
	min-height: 24px;
	background-color: #FFF5E8;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 16px;
	line-height: 18px;
	color: #262626;
	padding-left: 24px;
	padding-right: 24px;
	padding-top: 2px;
	padding-bottom: 2px;
}

.warning_icon {
	transform: translateY(1px);
	width: 16px;
	height: 16px;
	color: #FF9A1E !important;
}

.warning span {
	padding-top: 1px;
	padding-left: 14px;
}

.clickable_link {
	color: #007FAF !important;
	text-decoration: none;
}

.text_input_wrong_udaje {
	border-bottom: 2px solid #FF9A1E !important;
}

.hide {
	display: none !important;
}

.potize_s_prihlasenim {
	display: none;
	text-align: center;
	margin-top: 30px;
	margin-bottom: 8px;
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #007FAF;
}

@supports (-webkit-touch-callout: none) {
	/* CSS specific to iOS devices */
	.login_headline, .input_headline, .message_upresneni, .text_input, .warning, .potize_s_prihlasenim {
		letter-spacing: -0.05rem !important;
	}
}

@media only screen and (max-width: 770px) {

	.potize_s_prihlasenim {
		display: block;
	}

	.btn_main {
		font-size: 21px;
	}

	.background-white {
		width: 100%;
		padding-left: 0px;
		padding-right: 0px;
	}

	.input_headline, .text_input, .btn_main, .warning, .message_upresneni {
		margin-left: 16px !important;
		margin-right: 16px !important;
		width: calc(100% - 32px);
	}

	.warning {
		display: grid;
		grid-template-columns: 25px 1fr;
		font-family: "TeleNeoLocalRegular";
		-webkit-font-smoothing: antialiased !important;
		text-rendering: optimizeLegibility !important;
		font-weight: 400 !important;
		font-size: 14px !important;
		line-height: 16px !important;
		padding-left: 0px !important;
		padding-right: 0px !important;
	}

	.warning span {
		padding-left: 0px !important;
		place-self: center left;
	}

	.warning a {
		font-family: "TeleNeoLocalMedium";
		-webkit-font-smoothing: antialiased !important;
		text-rendering: optimizeLegibility !important;
		font-weight: 500 !important;
	}

	.warning_icon {
		transform: translateY(0px);
		width: 11px !important;
		height: 11px !important;
		margin-left: 7px;
		place-self: center left;
	}
}
</style>
